import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";

// material-ui

import MenuItem from "@mui/material/MenuItem";
import { Get_One_From_MongoDB } from "../../../api/Get_One_From_MongoDB";

import { Update_To_MongoDB_By_ID } from "../../../api/Update_To_MongoDB_By_ID";
import { Post_To_MongoDB } from "../../../api/Post_To_MongoDB";
import { Get_limited_Choose_Fields_With_Sort_From_MongoDB } from "../../../api/Get_limited_Choose_Fields_With_Sort_From_MongoDB";

import ViewBursaries from "./ViewBursaries";
import GetClientAddress from "../../../../functions/GetClientAddress";
import ViewEvents from "./ViewEvents";
import ViewHubspot from "./ViewHubspot";
import ViewEvents2024 from "./ViewEvents2024";
import { StaffuseAuth } from "../../../security/StaffuseAuth";

const ViewSchool = () => {
  const { logout } = StaffuseAuth();

  //the below gets the id from the URL
  const { id } = useParams();

  //This is the state for the school
  const [School, setSchool] = useState({
    _id: id,
    HubspotCompanyID: "",
    School_PS: "",
  });

  useEffect(() => {
    if (id !== "AddSchool") {
      Get_One_From_MongoDB("Schools", "All_Schools", id, setSchool, logout);
    }
  }, []);

  //This is the state for the update progress
  const [isSubmitting, setIsSubmitting] = useState(false);

  function handleAddSchool(e) {
    e.preventDefault();
    let data = School;
    delete data._id;
    Post_To_MongoDB(data, "Schools", "All_Schools", setIsSubmitting, logout);
  }

  function handleBasicUpdate(e) {
    e.preventDefault();
    let data = School;
    delete data._id;
    Update_To_MongoDB_By_ID(
      data,
      "Schools",
      "All_Schools",
      setIsSubmitting,
      id,
      logout
    );
  }

  function handleSchoolchange(e) {
    e.preventDefault();
    setSchool({ ...School, [e.target.name]: e.target.value });
  }

  //The below gets the staff
  const [Staff, setStaff] = useState([]);
  useEffect(() => {
    Get_limited_Choose_Fields_With_Sort_From_MongoDB(
      "Staff",
      "Users",
      100,
      { Username: 1 },
      setStaff,
      {
        Username: 1,
        Team: 1,
        Level: 1,
        _id: 1,
      },
      logout
    );
  }, []);

  //Filter the staff for PD's
  let PDStaff = Staff.filter((prop) =>
    prop.Team.toLowerCase().includes("pd".toLowerCase())
  );

  const handleCopy = () => {
    const textToCopy = GetClientAddress() + `Public/BursaryForm/${School._id}`;
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {})
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  //---------------------------------Components---------------------------------
  return (
    <div
      style={{
        backgroundColor: "#e5e5e5",
        minHeight: "93vh",
        paddingLeft: "10px",
        paddingTop: "10px",
        paddingRight: "10px",
        paddingBottom: "10px",
      }}
    >
      <h1 style={{ marginTop: "0px" }}>View School: {School._id}</h1>
      {School.School_PS && School.School_PS === "Yes" ? (
        <h4 style={{ marginTop: "0px" }}>
          Personal Bursary Form Link:
          <br></br>
          {GetClientAddress()}Public/BursaryForm/
          {School._id}
          <br></br>
          <button onClick={handleCopy} style={{ maxWidth: "5%" }}>
            Copy
          </button>
        </h4>
      ) : (
        <></>
      )}

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <section>
            <h2>Basic Info</h2>
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <TextField
                  key="_id"
                  name="_id"
                  label="_id"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={School["_id"]}
                  onChange={(e) => handleSchoolchange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                  disabled
                  InputLabelProps={{ shrink: true }}
                />
                <TextField
                  key="School_Name"
                  name="School_Name"
                  label="School_Name"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={School["School_Name"]}
                  onChange={(e) => handleSchoolchange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                  InputLabelProps={{ shrink: true }}
                />
                <TextField
                  key="School_Country"
                  name="School_Country"
                  label="School_Country"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={School["School_Country"]}
                  onChange={(e) => handleSchoolchange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                  InputLabelProps={{ shrink: true }}
                />
                <TextField
                  key="School_PostCode"
                  name="School_PostCode"
                  label="School_PostCode"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={School["School_PostCode"]}
                  onChange={(e) => handleSchoolchange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                  InputLabelProps={{ shrink: true }}
                />
                <TextField
                  key="School_Region"
                  name="School_Region"
                  label="School_Region"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={School["School_Region"]}
                  onChange={(e) => handleSchoolchange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  key="School_Type"
                  name="School_Type"
                  label="School_Type"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    School && School["School_Type"] ? School["School_Type"] : ""
                  }
                  onChange={(e) => handleSchoolchange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                  InputLabelProps={{ shrink: true }}
                  select
                >
                  <MenuItem value="Academies">Academies</MenuItem>
                  <MenuItem value="College">College</MenuItem>
                  <MenuItem value="Free Schools">Free Schools</MenuItem>
                  <MenuItem value="Independent School">
                    Independent School
                  </MenuItem>
                  <MenuItem
                    value="Local
              authority maintained schools"
                  >
                    Local authority maintained schools
                  </MenuItem>
                  <MenuItem
                    value="Special
              schools"
                  >
                    Special schools
                  </MenuItem>
                  <MenuItem value="Universities">Universities</MenuItem>
                  <MenuItem value="Virtual School">Virtual School</MenuItem>
                  <MenuItem value="Other">Other</MenuItem>
                </TextField>
                <TextField
                  key="School_Boarding"
                  name="School_Boarding"
                  label="School_Boarding"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    School && School["School_Boarding"]
                      ? School["School_Boarding"]
                      : ""
                  }
                  onChange={(e) => handleSchoolchange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                  InputLabelProps={{ shrink: true }}
                  select
                >
                  <MenuItem value=""></MenuItem>
                  <MenuItem value="Boarding">Boarding</MenuItem>
                  <MenuItem value="No">No</MenuItem>
                </TextField>
                <TextField
                  key="School_Website"
                  name="School_Website"
                  label="School_Website"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={School["School_Website"]}
                  onChange={(e) => handleSchoolchange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                  InputLabelProps={{ shrink: true }}
                />
                <TextField
                  key="School_Capacity"
                  name="School_Capacity"
                  label="School_Capacity"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={School["School_Capacity"]}
                  onChange={(e) => handleSchoolchange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                  InputLabelProps={{ shrink: true }}
                  type="number"
                />
                <TextField
                  key="School_Dukes"
                  name="School_Dukes"
                  label="School_Dukes"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    School && School["School_Dukes"]
                      ? School["School_Dukes"]
                      : ""
                  }
                  onChange={(e) => handleSchoolchange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                  InputLabelProps={{ shrink: true }}
                  select
                >
                  <MenuItem value="Yes">Yes</MenuItem>
                  <MenuItem value="No">No</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={4}>
                <TextField
                  key="School_PD"
                  name="School_PD"
                  label="School_PD"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    School && School["School_PD"] ? School["School_PD"] : ""
                  }
                  onChange={(e) => handleSchoolchange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                  InputLabelProps={{ shrink: true }}
                  select
                >
                  <MenuItem value="">Null</MenuItem>
                  {PDStaff.map((Staff) => (
                    <MenuItem key={Staff.Username} value={Staff.Username}>
                      {Staff.Username ? Staff.Username : ""}
                    </MenuItem>
                  ))}
                </TextField>
                <TextField
                  key="School_DateAssigned"
                  name="School_DateAssigned"
                  label="School_DateAssigned"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={School["School_DateAssigned"]}
                  onChange={(e) => handleSchoolchange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                  InputLabelProps={{ shrink: true }}
                />
                <TextField
                  key="School_PS"
                  name="School_PS"
                  label="School_PS"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    School && School["School_PS"] ? School["School_PS"] : ""
                  }
                  onChange={(e) => handleSchoolchange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                  InputLabelProps={{ shrink: true }}
                  select
                >
                  <MenuItem value="Yes">Yes</MenuItem>
                  <MenuItem value="No">No</MenuItem>
                </TextField>
                <TextField
                  key="School_PS_Code"
                  name="School_PS_Code"
                  label="School_PS_Code"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    School["School_PS_Code"] ? School["School_PS_Code"] : ""
                  }
                  onChange={(e) => handleSchoolchange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                  InputLabelProps={{ shrink: true }}
                />
                <TextField
                  key="School_Charity"
                  name="School_Charity"
                  label="School_Charity"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={
                    School && School["School_Charity"]
                      ? School["School_Charity"]
                      : ""
                  }
                  onChange={(e) => handleSchoolchange(e)}
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                  InputLabelProps={{ shrink: true }}
                  select
                >
                  <MenuItem value="">---</MenuItem>
                  <MenuItem value="Yes">Yes</MenuItem>
                  <MenuItem value="No">No</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id="School_PostitNote"
                  label="Personal Notes & Doodles"
                  value={
                    School["School_PostitNote"]
                      ? School["School_PostitNote"]
                      : ""
                  }
                  name="School_PostitNote"
                  onChange={(e) => handleSchoolchange(e)}
                  InputLabelProps={{ shrink: true }}
                  style={{ width: "97%" }}
                  multiline
                  rows={5}
                  fullWidth
                  InputProps={{
                    style: {
                      backgroundColor: "white",
                    },
                  }}
                />
              </Grid>
            </Grid>
          </section>
        </Grid>
      </Grid>
      <h1>Actions</h1>
      <Button
        type="submit"
        variant="contained"
        sx={{ mt: 3, ml: 1 }}
        disabled={isSubmitting}
        onClick={(e) =>
          id === "AddSchool" ? handleAddSchool(e) : handleBasicUpdate(e)
        }
      >
        {isSubmitting
          ? "Submitting..."
          : id === "AddSchool"
          ? "Add School"
          : "Update School"}
      </Button>
      <ViewEvents2024 id={id} />
      <ViewEvents id={id} />
      <ViewHubspot
        id={id}
        School={School}
        setSchool={setSchool}
        handleSchoolchange={handleSchoolchange}
      />
      <ViewBursaries id={id} />
    </div>
  );
};

export default ViewSchool;
